import React, {useContext, useEffect, useState} from 'react';
import {DateHelper} from "@bryntum/schedulerpro";
import BryntumContext from "../../../context/bryntumContext.jsx";
import {TriggerKeyForLastUpdatedAt} from "../../../../other/constants/OtherKeys.jsx";
import useNetworkState from "../../../hooks/useNetworkState.jsx";
import { formatNameWithInitials } from '../../../../other/utils/utils.jsx';

let lastUpdateBoardUpdateListener = null;
const LastUpdateText = () => {
  const [lastUpdated, setLastUpdated] = useState(null);
  const { isNetworkRequestInProgress } = useNetworkState();
  const { project, boardManager, selectedBoard } = useContext(BryntumContext);

  useEffect(() => {
    if (project && selectedBoard) {
      setLastUpdated({
        updater: selectedBoard.record.updater,
        updatedAt: selectedBoard.record.updatedAt
      })
      return project.on(TriggerKeyForLastUpdatedAt, ({ updater, updatedAt }) => {
        setLastUpdated({ updater, updatedAt });
      })
    }
  }, [project, selectedBoard]);

  useEffect(() => {
    if (project && boardManager.boardNameStore) {
      lastUpdateBoardUpdateListener = boardManager.boardNameStore.on("update", ({ record }) => {
        if (boardManager.selectedBoard.id === record.id) {
          project.trigger(TriggerKeyForLastUpdatedAt, record);
        }
      });
      return () => lastUpdateBoardUpdateListener();
    }
  }, [project, boardManager.boardNameStore]);

  return (
    <>
      { lastUpdated && <div className='text-muted-foreground text-xs leading-tight'>
        <span className="flex items-center gap-1.5 text-xs">
          {/* loader only shows up when lastUpdated is available because showing only loader in the middle of the header was not looking good. */}
          <i className={`fa-duotone fa-loader fa-spin text-xs leading-none ${isNetworkRequestInProgress ? "opacity-1" : "opacity-0"}`} />
          {lastUpdated.updater ? `${formatNameWithInitials(lastUpdated.updater)}, ` : ''}
          {DateHelper.format(new Date(lastUpdated.updatedAt), 'ddd M/D')} at{" "}
          {DateHelper.format(new Date(lastUpdated.updatedAt), 'h:mm A')}
        </span>
      </div> }
    </>
  );
};

export default LastUpdateText;
